const JiraIcon = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_17674_89797)">
<path d="M22.9366 0H11.4099C11.4099 1.38001 11.9581 2.7035 12.9339 3.67931C13.9097 4.65513 15.2332 5.20333 16.6132 5.20333H18.7366V7.25333C18.7384 10.1245 21.0655 12.4515 23.9366 12.4533V1C23.9366 0.447715 23.4889 0 22.9366 0Z" fill="#2684FF"/>
<path d="M17.2335 5.74341H5.70679C5.70863 8.61453 8.03567 10.9416 10.9068 10.9434H13.0301V13.0001C13.0338 15.8712 15.3623 18.1967 18.2335 18.1967V6.74341C18.2335 6.19112 17.7857 5.74341 17.2335 5.74341Z" fill="url(#paint0_linear_17674_89797)"/>
<path d="M11.5267 11.4834H0C0 14.3571 2.32961 16.6867 5.20333 16.6867H7.33333V18.7367C7.33517 21.6053 9.65815 23.9312 12.5267 23.9367V12.4834C12.5267 11.9311 12.079 11.4834 11.5267 11.4834Z" fill="url(#paint1_linear_17674_89797)"/>
</g>
<defs>
<linearGradient id="paint0_linear_17674_89797" x1="1233.71" y1="7.74347" x2="746.357" y2="516.27" gradientUnits="userSpaceOnUse">
<stop offset="0.18" stop-color="#0052CC"/>
<stop offset="1" stop-color="#2684FF"/>
</linearGradient>
<linearGradient id="paint1_linear_17674_89797" x1="1261" y1="17.15" x2="697.256" y2="571.792" gradientUnits="userSpaceOnUse">
<stop offset="0.18" stop-color="#0052CC"/>
<stop offset="1" stop-color="#2684FF"/>
</linearGradient>
<clipPath id="clip0_17674_89797">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>

    )
}
export default JiraIcon